// components/chat/CartaoContato.js — o cartão de contato dentro da bolha
// (nov/26).
//
// Até aqui o cartão que o cliente compartilhava virava só "Contato
// compartilhado" e o nome e o telefone se perdiam. Agora a bolha mostra de
// quem é, os números e, quando há, empresa e e-mail — e "Conversar" abre a
// nova conversa já preenchida com o primeiro número.
import { Box } from '@mui/material';
import { FiMessageCircle } from 'react-icons/fi';
import { formatarFone } from '../../pages/UserAdmin/crm/theme';

const SYNE = "'Syne', sans-serif";

const digitos = (t) => String(t?.wa_id || t?.phone || '').replace(/\D/g, '');

export default function CartaoContato({ contatos, enviada = false, onConversar }) {
  const legenda = enviada ? 'var(--ch-ob-m)' : 'var(--ch-cap)';
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px', width: { xs: 230, sm: 260 }, maxWidth: '100%' }}>
      {contatos.map((c, i) => {
        const tel = (c.telefones || [])[0];
        const mais = (c.telefones || []).length - 1;
        return (
          <Box key={i} sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', minWidth: 0 }}>
              <Box aria-hidden sx={{
                width: 40, height: 40, borderRadius: '50%', flexShrink: 0,
                bgcolor: 'var(--ch-av2-bg)', color: 'var(--ch-av2-fg)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontFamily: SYNE, fontSize: 16, fontWeight: 700,
              }}>
                {(c.nome || '?')[0]?.toUpperCase()}
              </Box>
              <Box sx={{ minWidth: 0 }}>
                <Box sx={{ fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{c.nome}</Box>
                {tel && (
                  <Box sx={{ fontSize: 13, color: legenda, fontVariantNumeric: 'tabular-nums' }}>
                    {formatarFone(digitos(tel)) || tel.phone}{mais > 0 ? ` · +${mais}` : ''}
                  </Box>
                )}
                {(c.empresa || c.emails?.[0]?.email) && (
                  <Box sx={{ fontSize: 12.5, color: legenda, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {[c.empresa, c.emails?.[0]?.email].filter(Boolean).join(' · ')}
                  </Box>
                )}
              </Box>
            </Box>
            {tel && onConversar && (
              <Box component="button" type="button"
                onClick={() => onConversar({ nome: c.nome || '', telefone: digitos(tel) })}
                sx={{
                  height: 34, border: 0, borderTop: `1px solid ${enviada ? 'var(--ch-ob-b)' : 'var(--ch-bdr)'}`,
                  bgcolor: 'transparent', color: 'var(--ch-blue)', cursor: 'pointer', font: 'inherit',
                  fontSize: 13.5, fontWeight: 600, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px',
                  '&:hover': { textDecoration: 'underline' },
                  '&:focus-visible': { outline: '2px solid var(--ch-green)', outlineOffset: 2, borderRadius: 6 },
                }}>
                <FiMessageCircle size={14} aria-hidden /> Conversar
              </Box>
            )}
          </Box>
        );
      })}
    </Box>
  );
}
